import Flickity from 'flickity';

function ImageTextCarousel(el) {
  let flickity = null;
  const carousel = el.querySelector('[data-carousel]');
  const prev = el.querySelector('[data-carousel-prev]');
  const next = el.querySelector('[data-carousel-next]');

  function getFlickity() {
    if (!flickity) {
      flickity = new Flickity(carousel, {
        cellSelector: '[data-carousel-slide]',
        wrapAround: true,
        lazyLoad: true,
        adaptiveHeight: true,
        pageDots: false,
        prevNextButtons: false,
      });

      flickity.resize();
    }

    return flickity;
  }

  prev.addEventListener('click', () => {
    flickity.previous();
  });

  next.addEventListener('click', () => {
    flickity.next();
  });

  function init() {
    getFlickity();
  }

  init();
}

export default ImageTextCarousel;
